import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DragDropDirective } from './dragDrop.directive';
import { EmbeddedSignComponent } from './embedded-sign/embedded-sign.component';
import { ConfigureUserComponent } from './pages/configure-user/configure-user.component';
import { ConfigureComponent } from './pages/configure/configure.component';
import { EmbeddedComponent } from './pages/embedded/embedded.component';
import { FileComponent } from './pages/form/form-components/file/file.component';
import { MessageComponent } from './pages/form/form-components/message/message.component';
import { FormComponent } from './pages/form/form.component';
import { LandingComponent } from './pages/landing/landing.component';
import { SignaturesComponent } from './pages/signatures/signatures.component';
import { WelcomeAuthenticateComponent } from './pages/welcome/authenticate/authenticate.component';
import { WelcomeCustomerDetailsComponent } from './pages/welcome/customer-details/customer-details.component';
import { WelcomePurchaseConfigureComponent } from './pages/welcome/purchase-configure/purchase-configure.component';
import { WelcomePurchaseFormComponent } from './pages/welcome/purchase-form/purchase-form.component';
import { WelcomePurchaseQuotesComponent } from './pages/welcome/purchase-quotes/purchase-quotes.component';
import { WelcomeSubscriptionTypeComponent } from './pages/welcome/subscription-type/subscription-type.component';
import { WelcomeTrialFormComponent } from './pages/welcome/trial-form/trial-form.component';

@NgModule({
	declarations: [
		AppComponent,
		ConfigureComponent,
		ConfigureUserComponent,
		EmbeddedComponent,
		EmbeddedSignComponent,
		FileComponent,
		FormComponent,
		LandingComponent,
		MessageComponent,
		SignaturesComponent,
		WelcomeAuthenticateComponent,
		WelcomeCustomerDetailsComponent,
		WelcomePurchaseConfigureComponent,
		WelcomePurchaseFormComponent,
		WelcomePurchaseQuotesComponent,
		WelcomeSubscriptionTypeComponent,
		WelcomeTrialFormComponent,
		DragDropDirective
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		ReactiveFormsModule,
		NgSelectModule,
		FormsModule,
		TooltipModule.forRoot(),
	],
	providers: [
		{ provide: LocationStrategy, useClass: PathLocationStrategy }
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
